import type {
    AdvancedSearchBody,
    ItemPageInfo,
    ItemsByField
} from "~/graphql/generated/schema-types";

type ExtendedItem = ItemPageInfo | ItemsByField

export function useDefineProduct() {
    const siteHost = 'https://csmarketcap.com';
    const {t} = useI18n();

    async function defineUseProduct(item: ExtendedItem) {
        const {mpn, sku} = getSkuMpn(item.market_hash_name || '');
        // @ts-ignore
        const localedName = item.localed_name || item.locals?.localed_name || item.market_hash_name || '';
        const highestPrice = ref(0);
        const lowestPrice = ref(0);
        const offers = ref(0);

        if ('price_range' in item && item.price_range) {
            highestPrice.value = item.price_range.highest_price || 0;
            lowestPrice.value = item.price_range.lowest_price || 0;
        } else if ('markets_offers' in item && item.markets_offers) {
            highestPrice.value = item.markets_offers?.[item.markets_offers.length - 1]?.price || item?.current_price || 0;
            lowestPrice.value = item.current_price || 0;
        }

        if ('offers' in item && item.offers) {
            offers.value = item.offers;
        } else if ('volume' in item && item.volume) {
            offers.value = item.volume.reduce((prev, curr) => prev + (curr?.offers || 0), 0);
        }

        const aggregateRating = (item.rating || item.rating?.rating || 0 > 0) ? {
            '@type': 'AggregateRating',
            ratingValue: item.rating?.rating || item.rating || 0,
            ratingCount: item.votes || item.rating?.votes || 0,
        } : null;

        const product: any = {
            '@context': 'https://schema.org',
            '@type': 'Product',
            name: localedName,
            description: t('heads.item.description', {name: item.market_hash_name || ''}),
            url: siteHost + getItemLinkWithoutExt({name: item.market_hash_name, slug: item.link}),
            image: () => getImageFromWaxpeer(item.market_hash_name),
            mpn: mpn || 'N/A',
            sku: sku || 'N/A',
            brand: {
                '@type': 'Brand',
                name: "CSMarketCap",
            },
            offers: {
                '@type': 'AggregateOffer',
                lowPrice: (lowestPrice.value / 1000).toFixed(2),
                highPrice: (highestPrice.value / 1000).toFixed(2),
                offerCount: offers.value || 1,
                availability: (offers.value || 0) > 0 ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock',
                priceCurrency: 'USD',
                seller: {
                    '@type': 'Organization',
                    name: 'CS Market Cap',
                }
            }
        };

        if (aggregateRating) {
            product.aggregateRating = aggregateRating;
        } else {
            product.offers = product.offers || null;
            product.review = null;
            product.aggregateRating = null;
        }

        return product;
    }

    return {defineUseProduct};
}

export function useDefineProductWithAdvSearchItem() {
    const siteHost = 'https://csmarketcap.com';
    const {t} = useI18n();

    async function defineUseProduct(item: AdvancedSearchBody) {
        const {mpn, sku} = getSkuMpn(item.market_hash_name || '');
        // @ts-ignore
        const localedName = item.localed_name || item.locals?.localed_name || item.market_hash_name || '';
        const highestPrice = ref(0);
        const lowestPrice = ref(0);
        const offers = ref(0);

        if (item.min_price && item.max_price) {
            highestPrice.value = item.max_price || 0;
            lowestPrice.value = item.min_price || 0;
        }

        if ('offers' in item && item.offers) {
            offers.value = item.offers;
        }

        // const aggregateRating = (item.rating && item.rating > 0) ? {
        //     '@type': 'AggregateRating',
        //     ratingValue: item.rating,
        //     ratingCount: item.votes || 0,
        // } : null;

        const product: any = {
            '@context': 'https://schema.org',
            '@type': 'Product',
            name: localedName,
            description: t('heads.item.description', {name: item.market_hash_name || ''}),
            url: siteHost + getItemLinkWithoutExt({name: item.market_hash_name, slug: item.link}),
            image: () => getImageFromWaxpeer(item.market_hash_name),
            mpn: mpn || 'N/A',
            sku: sku || 'N/A',
            brand: {
                '@type': 'Brand',
                name: "CSMarketCap",
            },
            offers: {
                '@type': 'AggregateOffer',
                lowPrice: (lowestPrice.value / 1000).toFixed(2),
                highPrice: (highestPrice.value / 1000).toFixed(2),
                offerCount: offers.value || 1,
                availability: (offers.value || 0) > 0 ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock',
                priceCurrency: 'USD',
                seller: {
                    '@type': 'Organization',
                    name: 'CS Market Cap',
                }
            }
        };

        // if (aggregateRating) {
        //     product.aggregateRating = aggregateRating;
        // } else {
        product.offers = product.offers || null;
        product.review = null;
        product.aggregateRating = null;
        // }

        return product;
    }

    return {defineUseProduct};
}
